import * as React from "react";

const PlayStore: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 125 30"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <rect width="125" height="30" fill="currentColor" rx="6" />
                <text fill="#00609C" fontFamily="Montserrat-SemiBold, Montserrat" fontSize="12" fontWeight="500">
                    <tspan x="34" y="19">
                        PLAY STORE
                    </tspan>
                </text>
                <path
                    fill="#00609C"
                    d="M14.466 7.255c1.476 1.506 2.956 3.007 4.44 4.505l2.88 2.91c.096.09.102.143 0 .238a2372.319 2372.319 0 00-7.046 7 .25.25 0 01-.387 0 .894.894 0 01-.345-.758v-6.616l-.006-6.568a.974.974 0 01.244-.711c.072-.083.125-.1.22 0zm7.916 7.997c.553.592 1.119 1.144 1.684 1.707.095.1.107.136 0 .213l-8.433 4.6c-.04.026-.078.053-.113.083a5245.75 5245.75 0 006.546-6.603c.137-.137.197-.119.316 0zm2.612-2.713a.174.174 0 01.012.01l2.524 1.393c.268.111.45.363.47.652a.688.688 0 01-.304.551 3.69 3.69 0 01-.416.255l-2.547 1.399a.191.191 0 01-.268-.028l-.006-.008c-.595-.592-1.19-1.233-1.821-1.85-.09-.088-.09-.136 0-.224.714-.7 1.422-1.401 2.124-2.105a.168.168 0 01.232-.045zM14.847 7c.151 0 .299.041.429.119l9.028 5.044c.143.077.137.119 0 .226-.65.64-1.31 1.302-1.976 1.985-.071.072-.119.113-.214 0l-7.19-7.28L14.848 7z"
                />
            </g>
        </svg>
    );
};

export default React.memo(PlayStore);
